import { Component, inject } from '@angular/core';
import { AreaTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  AreaTypeCreateDto,
  AreaTypeDto,
  AreaTypeExcelDownloadDto,
  AreaTypeUpdateDto,
} from '../proxy/planning/dtos/area-type';
import { AREATYPE_CONFIG, AREATYPE_FIELDS } from './area-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-area-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, AreaTypeService, ConfirmationService],
  templateUrl: './area-type.html',
  styleUrl: './area-type.scss',
})
export class AreaType extends BaseCrudComponent<
  AreaTypeDto,
  AreaTypeCreateDto,
  AreaTypeUpdateDto,
  AreaTypeExcelDownloadDto
> {
  service = inject(AreaTypeService);
  config = AREATYPE_CONFIG;
  fields = AREATYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: AreaTypeDto): AreaTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'AreaType';
  }
}
